








import { Component, Vue, Prop } from "vue-property-decorator";
import { Company, Office } from "@/api/company-api";
import saveCompany from "@/helpers/saveCompany";
import TaskType from "@/entities/task-type";
import CompanyEdit from "@/templates/CompanyEdit.vue";
import createCompany from "@/helpers/createCompany";

@Component({
  components: {
    CompanyEdit
  }
})
export default class CompanyNewPage extends Vue {
  @Prop({ default: "" }) companyType!: string;

  company: Company | null = null;
  office: Office | null = null;

  async ok() {
    if (!this.company || !this.office) return;
    await saveCompany(this.company, this.office);
    this.goListPage();
  }

  cancel() {
    this.goListPage();
  }

  remove() {
    this.goListPage();
  }

  private created() {
    this.$store.dispatch("tasktype/init");
    [this.company, this.office] = createCompany();
  }

  private goListPage() {
    this.$router.push({ name: "enduser-list" });
  }

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }
}
